import { createEnum } from './options'

// #region 订阅周期
/**
 * 订阅周期
 */
export const SubscriptionCycle = createEnum([
  { value: 6, key: 'OneDay', label: '1 Day', days: '1 Day' },
  { value: 7, key: 'ThreeDays', label: '3 Days', days: '3 Days' },
  { value: 1, key: 'WEEK', label: 'Weekly', days: '7 Days' },
  { value: 2, key: 'MONTH', label: 'Monthly', days: '30 Days' },
  { value: 3, key: 'SEASON', label: 'Seasonal', days: '90 Days' },
  { value: 4, key: 'HALF_YEAR', label: 'Semi-Annual', days: '182 Days' },
  { value: 5, key: 'YEAR', label: 'Annual', days: '365 Days' },
] as const)
// #endregion

// #region RECHARGE_TYPE_NAME
export const RECHARGE_TYPE_NAME = createEnum([
  { value: 1, key: 'Recharge', label: 'rechargeType.Recharge' },
  { value: 2, key: 'ChargeGive', label: 'rechargeType.ChargeGive' },
  { value: 3, key: 'VIPCharge', label: 'rechargeType.VIPCharge' },
  { value: 4, key: 'SystemOperate', label: 'rechargeType.SystemOperate' },
  { value: 5, key: 'SystemCompensation', label: 'rechargeType.SystemCompensation' },
  { value: 6, key: 'ActivityCharge', label: 'rechargeType.ActivityCharge' },
  { value: 7, key: 'ActivityChargeGive', label: 'rechargeType.ActivityChargeGive' },
  { value: 8, key: 'ActivityGive', label: 'rechargeType.ActivityGive' },
  { value: 9, key: 'SubscribeDeduct', label: 'rechargeType.SubscribeDeduct' },
  { value: 10, key: 'ExpireZero', label: 'rechargeType.ExpireZero' },
  { value: 11, key: 'CheckIn', label: 'rechargeType.CheckIn' },
  { value: 12, key: 'AD', label: 'rechargeType.AD' },
  { value: 13, key: 'Email', label: 'rechargeType.Email' },
  { value: 14, key: 'Subscription', label: 'rechargeType.Subscription' },
  { value: 15, key: 'SubscriptionDiscount', label: 'rechargeType.SubscriptionDiscount' },
  { value: 23, key: 'Task', label: 'rechargeType.Task' },
] as const)
// #endregion

// #region TASK_TYPE
export enum TASK_TYPE {
  /** 绑定第三方账号 */
  BIND = 0,
  /** 添加到外部浏览器 */
  ADD_BROWSER = 1,
  /** 加桌 */
  ADD_TO_HOME_SCREEN = 2,
}
// #endregion
